module.exports = __webpack_public_path__ + "static/media/81V7L6auixL._SL1500_.5d2809ca.jpg";